<template>
    <div>
        <c-search-form :input-search-items="searchItems" :rows-per-page-items="[10,20,50]"
                       :input-create-items="createItems"
                       :form-name="formName" :create-form-name="createFormName"
                       model="searchForm" :fields="fields"
                       accept-copy
                       accept-delete
                       accept-view-present
                       @viewPresent="viewPresent"
                       @viewDocument="viewDocument"
                       accept-view-document
                       key-property="customerId"
                       search-url="/customer/search"
                       create-url="/customer/save"
                       delete-url="/customer/delete">
            <customer-create id="createDiv" slot="createForm"
                        :create-form-name="createFormName"
                        style="display: none"
                        create-url="/customer/save"/>



        </c-search-form>
        <view-present :customer-id="customerId" :cDialog = "viewPresentDialog" @closePresent = "closePresent"/>
        <customer-document :customer-id="customerId" :cDialog = "customerDocumentDialog" @close = "closeDocument"/>
    </div>


</template>

<script>
    import CSearchForm from "../../../../components/form/ListForm";
    import axios from "axios";
    import {dbConstants} from "../../../../constants";
    import CustomerCreate from "./CustomerCreate";
    import ViewPresent from "./ViewPresent";
    import CustomerDocument from "./CustomerDocument";

    export default {
        name: 'customer-management',
        components: {ViewPresent, CustomerCreate, CSearchForm, CustomerDocument},
        data: () => {
            return {
                formName: "lang.customer.customerForm",
                createFormName: "lang.customer.createCustomer",
                subjects: [],
                customerId: -1,
                cDialog: false,
                viewPresentDialog: false,
                customerDocumentDialog: false,
                searchDiv123: "searchDiv123",
                searchItems: [
                    {
                        type: "text",
                        name: "customerName",
                        label: "lang.customer.customerName",
                        placeHolder: "",
                        focus: true
                    }
                    ,
                    {
                        type: "text",
                        name: "email",
                        label: "lang.customer.email",
                        placeHolder: ""
                    }
                ],
                createItems: [
                    {
                        type: "text",
                        name: "customerName",
                        label: "lang.customer.customerName",
                        validate: "required",
                        maxlength: '50',
                        placeHolder: "",
                        errorText: "Lỗi"
                    },
                    {
                        type: "text",
                        name: "email",
                        label: "lang.customer.email",
                        validate: "required|email",
                        maxlength: "25",
                        placeHolder: ""
                    }
                ],
                fields: [
                    {
                        value: "index",
                        text: "lang.common.index",
                        width: "5%",
                        sortable: false,
                        headerStyle: "text-align:center"
                    },
                    {
                        value: 'customerName',
                        text: 'lang.customer.customerName',
                        width: "40%",
                        sortable: false,
                        headerStyle: "text-align:left"
                    },
                    {
                        value: 'email',
                        text: 'lang.customer.email',
                        width: "30%",
                        sortable: false,
                        headerStyle: "text-align:left"
                    },
                    {
                        value: 'action',
                        text: 'lang.customer.action',
                        width: "25%",
                        sortable: false,
                        compound: true,
                        headerStyle: "text-align:left"
                    }
                ]
            }
        },
        methods: {
            viewPresent: function(item) {
                this.customerId = item.customerId;

                this.viewPresentDialog = true;
                console.log("ViewPresent", this.customerId);
            },
            closePresent: function(data) {
                this.customerId = -1;
                this.viewPresentDialog = false;
                console.log("this.customerId", this.customerId);
            },

            viewDocument: function(item) {

                this.customerId = item.customerId;
                this.customerDocumentDialog = true;
                console.log("View Document", this.customerId);
            },
            closeDocument: function(data) {
                this.customerId = -1;
                this.customerDocumentDialog = false;
                console.log("this.customerId", this.customerId);
            },
        },
        created() {
            // axios.post(process.env.VUE_APP_API_URL + "/subject/listForSelect").then(
            //     data => {
            //         this.createItems[2].items = data;
            //         this.searchItems[2].items = data;
            //     },
            //     error => {
            //
            //     }
            // )
        }
    }
</script>
